import React from 'react';
import { Link } from 'react-router-dom';
import type { ButtonConfig } from '@/config/homePageConfig';

interface ConfigurableButtonProps {
  config: ButtonConfig;
}

const ConfigurableButton: React.FC<ConfigurableButtonProps> = ({ config }) => {
  const getButtonClasses = (variant: 'primary' | 'secondary') => {
    if (variant === 'primary') {
      return "w-full bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg font-semibold transition-colors";
    }
    return "w-full border-2 border-blue-600 text-blue-600 hover:bg-blue-600 hover:text-white px-8 py-3 rounded-lg font-semibold transition-colors";
  };

  if (config.variant === 'secondary' && config.requiredRole === 'admin') {
    return (
      <Link
        to={config.to}
        className="w-full bg-gray-800 hover:bg-gray-900 text-white px-8 py-3 rounded-lg font-semibold transition-colors"
      >
        {config.label}
      </Link>
    );
  }

  return (
    <Link
      to={config.to}
      className={getButtonClasses(config.variant)}
    >
      {config.label}
    </Link>
  );
};

export default ConfigurableButton;